import { Button, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';
import { useLocation } from 'react-router-dom';

const InvoiceLst = ({ jobPayment, fileCount }) => {
    return (
        jobPayment.item_lst.map(item => {
            return (
                <Grid container sx={{ py: 2, minWidth: 800, borderBottom: "1px solid lightgrey" }} spacing={{ xs: 3, sm: 4, md: 6 }} alignItems="stretch">
                    <Grid item xs={3} sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: 'center' }} >
                        <Box >
                            <Typography sx={{ fontSize: '15px' }}>{item.title}</Typography>
                        </Box>

                    </Grid>
                    <Grid item xs={3} sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: 'center' }} >
                        <Box >
                            <Typography sx={{ fontSize: '15px' }}>{item.item_price}</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={3} sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: 'center' }} >
                        <Box >
                            <Typography sx={{ fontSize: '15px' }}>
                                {item.item_type === 'turn around time' ? "--" : (fileCount === 0 ? item.file_count : fileCount)}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={3} sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: 'center' }} >
                        <Box >
                            <Typography sx={{ fontSize: '15px' }}>
                                {item.item_type === 'turn around time' ? item.item_total : (fileCount === 0 ? item.item_total : (fileCount * item.item_price))}
                            </Typography>
                        </Box>
                    </Grid>

                </Grid>
            )
        })
    )
}

const EditInvoice = () => {
    const theme = useTheme()
    const location = useLocation();
    const jobPayment = location.state;
    const [changeFileCountModel, setChangeFileCountModel] = useState(false)
    const [fileCount, setFileCount] = useState(0)

    return (
        <Box sx={{}}>
            <>
                <Typography
                    sx={{ m: 2, flex: '1 1 100%', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                    id="tableTitle"
                    component="div"
                >
                    Invoice
                </Typography>
                <Box sx={{ textAlign: 'right', m: 4 }}>
                    <Button
                        variant='outlined'
                        onClick={() => { setChangeFileCountModel(true) }}
                    >
                        Change File count
                    </Button>
                </Box>
                <Paper sx={{ mt: 7, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)", overflow: "auto", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} className="overflow-scroll">

                    <Box>
                        <Grid container spacing={{ xs: 3, sm: 4, md: 6 }} sx={{ py: 2, minWidth: 800, borderBottom: "1px solid lightgrey" }}>
                            <Grid item xs={3} sx={{ textAlign: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>Service</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ textAlign: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>Unit Price</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ textAlign: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>Image Count</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ textAlign: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>Total</Typography>
                            </Grid>
                        </Grid>
                        <InvoiceLst
                            jobPayment={jobPayment}
                            fileCount={fileCount}
                        />
                        <Grid container spacing={{ xs: 3, sm: 4, md: 6, }} sx={{ py: 2, mb: 2, minWidth: 800, borderBottom: "1px solid lightgrey" }}>
                            <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                <Typography>Total</Typography>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: 'center' }}>
                                <Typography>{jobPayment.net_price}</Typography>
                            </Grid>
                        </Grid>
                        <Box sx={{ textAlign: "right", pr: 3 }}>
                            <Button variant='contained' >Update Invoice</Button>
                        </Box>
                    </Box>
                </Paper>
            </>

            <Dialog
                open={changeFileCountModel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Change file count ?</DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        <TextField label="File Count" variant="outlined" type='number' onChange={(e) => setFileCount(e.target.value)} fullWidth />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setChangeFileCountModel(false)}>Change</Button>
                    <Button onClick={() => { setChangeFileCountModel(false); setFileCount(0) }}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default EditInvoice